import { ISixPlusPokerGameState, ISixPlusPokerSelectData } from './interfaces';

/**
 * WARNING:
 * Don't allow to hard code odd ids in Six Plus Poker
 * On different infrastructures we have different odds ids in the BE
 */
export const sixPlusPokerSelectors = {
    selectData: (state: ISixPlusPokerGameState): ISixPlusPokerSelectData => ({
        ...state.data,
        mainBettingOptions: state.oddGroups[0].ids.map((id) => state.data.bettingOptions[id]),
        combinationBettingOptionsGroup: {
            id: state.oddGroups[1].id,
            options: state.oddGroups[1].ids.map((id) => state.data.bettingOptions[id]),
        },
        oddsGroups: state.oddGroups,
    }),
};
